
<template>
  <router-link :to="href">
    <span class="href-text-ui"  :style="style">
      <slot></slot> <img v-if="arrow" class="arrow-next" src="/static/img/next-controll.svg" />
    </span>
  </router-link>
</template>

<script>
export default {

    name: 'UITextHref',

    props: {
      color: {
        type: String,
        default: '#9D9D9D'
      },
      href: {
        type: String,
        required: true
      },
      arrow: {
        type: Boolean,
        default: true
      },
    },

    computed: {
      style () {
        return {
          '--color': this.color
        }
      }
    },
}
</script>

<style>
  .href-text-ui{
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 33px;
    
    width: max-content;
    color: var(--color);
  }
  @media (min-width: 850px) {
    .href-text-ui{
      font-size: 24px;
      line-height: 33px;
    }
    .href-text-ui .arrow-next{
      height: 15px;
      width: 9px;
    }
  }
  @media (max-width: 1650px) {
    .href-text-ui{
      font-size: 23px;
      line-height: 1em;
    }
    .href-text-ui .arrow-next{
      height: 15px;
      width: 9px;
    }
  }
  @media (max-width: 1350px) {
      .href-text-ui{
        font-size: 20px;
        line-height: 1em;
      }
      .href-text-ui .arrow-next{
        height: 15px;
        width: 9px;
      }
  }
  @media (max-width: 850px) {
      .href-text-ui{
        font-size: 12px;
        line-height: 14px;
      }
      .href-text-ui .arrow-next{
        height: 15px;
        width: 9px;
      }
  }
</style>



// WEBPACK FOOTER //
// UITextHref.vue?ec3aafca